<!--
 * @Author: your name
 * @Date: 2020-10-22 19:45:51
 * @LastEditTime: 2020-10-29 17:22:24
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \IvanProject\drugstore-prescription-admin-pc\src\components\activity\activityBanner.vue
-->
<template>
  <div class="activity" v-if="pcTopBanner.length">
    <el-carousel indicator-position="none" arrow="never">
      <el-carousel-item v-for="(item, index) in pcTopBanner" :key="index">
        <el-popover placement="bottom" width="730" trigger="hover">
          <div>
            <img :src="item.imgUrl" alt="" style="width: 702px" />
          </div>
          <div class="img-box" slot="reference">
            <img :src="item.imgUrl" @click="handleClick(item)" alt="banner" />
          </div>
        </el-popover>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  // props: {
  //   pcTopBanner: {
  //     type: Array
  //   }
  // },
  data() {
    return {};
  },
  computed: {
    // pc左侧活动
    pcTopBanner() {
      const { resourcePutObj } = this.$store.getters;
      const RESOURCE_TYPE = 'PC_TOP_BANNER';
      if (resourcePutObj[RESOURCE_TYPE]) return resourcePutObj[RESOURCE_TYPE];
      return [];
    },
    // pc左侧活动是否展示
    pcTopBannerShow() {
      const { pcTopBanner } = this;
      if (pcTopBanner.length) {
        const { id } = pcTopBanner[0];
      }
      if (pcTopBanner.length) {
        Telescope.trackEvent({
          trackId: 'zywzpc-click-biaoqian-b'
        });
      }

      return !!pcTopBanner.length;
    }
  },
  methods: {
    handleClick({ linkUrl, id }) {
      if (!linkUrl) return;
      const { companyName, companyId, isChain, ucUserId, roleListFromBk, mobile } = this.$store.state.global;
      Telescope.trackEvent({
        trackId: 'zywzpc-click-biaoqian-d',
        custom: {
          companyId,
          companyName,
          userId: ucUserId,
          mobile,
          isChain,
          roleList: roleListFromBk,
          time: new Date().getTime()
        }
      });
      // 待参数给跳转页面
      let query =
        linkUrl.indexOf(location.origin) >= 0
          ? 'resourceType=PC_DIALOG'
          : `userId=${ucUserId}&resourceType=PC_TOP_BANNER`;
      query = linkUrl.indexOf('?') > -1 ? `&${query}` : `?${query}`;
      linkUrl = `${linkUrl}${query}`;

      window.open(linkUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.activity {
  width: 140px;
  margin-top: 6px;
  margin-right: 44px;
  border-radius: 4px;
  height: 35px;
  cursor: pointer;
  .img-box {
    height: 35px;
    width: 140px;
    margin: 0;
  }
  img {
    width: 100%;
  }

  /deep/.el-carousel__container {
    height: 50px;
  }
}
</style>
